export const SET_PICKER_DATE = 'orderTime/SET_PICKER_DATE';

export const SET_PICKUP_DATE_TIME = 'orderTime/SET_PICKUP_DATE_TIME';
